import styled from "styled-components";

export const FirstSection = styled.section`
   position: relative;
  &::before {
    top: -112px;
    left: 0;
    content: '';
    width: 100%;
    height: 100%;
    display: inline-block;
    position: absolute;
    //background: url("https://www.ibsaderma.fr/wp-content/uploads/2020/12/neck-and-de%CC%81collete%CC%81.jpg") no-repeat center center;
  }
`;

export const FirstSecArrow = styled.img`
  position: relative;
  display: block;
  margin-right: auto;
  margin-top: 2rem;
  left: -2rem;
  
  @media (max-width: 992px) {
    left: 1rem;
    bottom: 118%;
    position: absolute;
    margin-top: 0;
    -webkit-transform: rotateZ(120deg);
    -ms-transform: rotateZ(120deg);
    transform: rotateZ(120deg);
    width: 230px;
  }

  @media (max-width: 768px) {
    left: -1rem;
    bottom: 110%;
    width: 200px;
  }
`;

export const RoundWrapper = styled.div`
  position: relative;
  background-color: #FFFFFF;
  border-radius: 59px;
  border: 1px solid rgba(108, 140, 191, 0.33);
  width: 140px;
  height: 140px;
  display: flex;
  margin: auto;
  align-items: center;
  justify-content: center;
  box-shadow: -1px 31px 80px 0px rgba(108, 140, 191, 0.13);
  -webkit-box-shadow: -1px 31px 80px 0px rgba(108, 140, 191, 0.13);
  -moz-box-shadow: -1px 31px 80px 0px rgba(108, 140, 191, 0.13);
  transition: .5s;

  &:hover {
    transform: scale(1.08);
  }

  i {
    font-size: 3.5rem;
    z-index: 2;
    position: relative;
  }

  &:after {
    content: '';
    width: 35px;
    height: 35px;
    display: inline-block;
    position: absolute;
    background-color: #ECF0F7;
    border-radius: 0 10px 0 23px;
    left: 70px;
    bottom: 70px;
  }

  @media (max-width: 992px) {
    width: 100px;
    height: 100px;
    border-radius: 38px;

    i {
      font-size: 2.5rem;
    }

    &:after {
      left: 45px;
      bottom: 45px;
      width: 25px;
      height: 25px;
    }
    
  }

  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
    border-radius: 25px;
    
    i {
      font-size: 2rem;
    }

    &:after {
      left: 32px;
      bottom: 32px;
      width: 20px;
      height: 20px;
    }
  }

`;

export const StatisticNumber = styled.p`
  color: var(--success-color);
  font-size: 1.8rem;
  margin-bottom: 0;
  margin-top: 2.5rem;
  text-align: center;
  direction: rtl;

  @media (max-width: 992px) {
    font-size: 1.5rem;
  }

  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin-top: 2rem;
  }
  
`;

export const StatisticText = styled.p`
  color: var(--light-gray-color);
  font-size: 1.2rem;
  margin-bottom: 0;
  margin-top: .8rem;
  text-align: center;

  @media (max-width: 992px) {
    font-size: 1rem;
  }

  @media (max-width: 768px) {
    font-size: .8rem;
  }
`;

export const ShiftsContainer = styled.div`
  div.swiper-slide:nth-child(odd) > div {
    margin-top: 2rem;
  }
`;

export const BackArrowImage = styled.img`
  position: absolute;
  margin-left: 5rem;
  top: 10px;
`;

export const WhyUsCard = styled.div`
  padding-left: 5rem;

  & > span {
    font-size: 3rem;
  }

  &:not(:first-child) {
    padding-right: 3rem;
  }

  &:not(:last-child) {
    border-left: 2px solid rgba(118, 133, 155, 0.15);
  }

  p {
    line-height: 2rem;
  }

  @media (max-width: 992px) {
    padding-bottom: 2rem;
    padding-left: 0;
    text-align: center;

    &:not(:first-child) {
      padding-right: 0;
    }
    
    &:not(:last-child) {
      border-left: 0;
      border-bottom: 2px solid rgba(118, 133, 155, 0.15);
      margin-bottom: 3rem;
    }

    p {
      padding: 0 1rem;
    }
    
  }
`;

export const CommentsContainer = styled.div`
  background-color: #F5F6F8;
  border-radius: 116px;
  padding: 6rem 4rem 6rem 2rem;
  
  @media (max-width: 992px) {
    padding: 3rem .8rem 3rem;
    border-radius: 0;
  }
`;

export const CommentTopBtn = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background-color: var(--dark-gray-color);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotateZ(-180deg);

  i {
    font-size: .5rem;
    font-weight: bold;
  }

  i::before {
    color: #FFFFFF;
  }

  @media (max-width: 992px) {
    transform: rotateZ(-90deg);
  }
`;

export const CommentBottomBtn = styled.button`
  background-color: transparent;
  border: none;
  width: 40px;
  height: 40px;
  padding: 0;
  position: relative;
  transform: rotateZ(90deg);

  i {
    font-size: 2.4rem;
  }

  @media (max-width: 992px) {
    margin-right: 2rem;
    transform: rotateZ(180deg);
  }
`;
